export const appViews = {
  // ── VideoGuides.vue ──
  guides: {
    openCenter: "Abrir central de guias",
    fabLabel: "Guias",
    assistantAria: "Assistente de guias",
    dontShowAgain: "Não mostrar novamente",
    centerAria: "Central de guias",
    eyebrow: "CENTRAL DE GUIAS",
    title: "Aprenda a usar o WACheckin",
    watchedOf: "{watched} de {total} assistidos",
    close: "Fechar",
    searchPlaceholder: "Buscar um guia…",
    forThisScreen: "Para esta tela",
    watched: "Assistido",
    watchGuide: "Assistir guia",
    comingSoon: "Em breve: novas melhorias e atualizações.",
    noResults: "Nenhum resultado para “{query}”.",
    needHelp: "Precisa de ajuda? ",
    contactWhatsApp: "Fale conosco no WhatsApp",
    lightboxMeta: "{section} · Guia {n} de {total}",
    videoTitle: "Vídeo do guia",
    playerAria: "Reprodutor de guias",
    prev: "Anterior",
    watchOnYouTube: "Assistir no YouTube",
    next: "Próximo",
    sections: {
      inicio: "Primeiros passos",
      alojamiento: "Sua propriedade",
      tarifas: "Tarifas e canais",
      calendario: "Calendário e reservas",
      huesped: "Experiência do hóspede",
      autoridades: "Autoridades",
      novedades: "Novidades",
    },
    videos: {
      navigate: "Acessar e navegar pelas configurações",
      propertyData: "Os dados, a localização e a identidade da sua propriedade",
      checkinWelcome: "Check-in, mensagem de boas-vindas e políticas",
      basePrices: "Preços base e tarifas derivadas dos canais",
      calendar: "Calendário: reservas, disponibilidade e preços",
      guestJourney: "A jornada do hóspede: mensagens, códigos e automações",
      guestVerification: "Verificação do hóspede e solicitação de avaliações",
      authorities: "Conectar autoridades e enviar relatórios de viajantes",
    },
    ai: {
      cta: "Ver a lista de vídeos",
      assistant: "Assistente",
      inicio: "Primeiro dia por aqui? Deixa eu te mostrar o básico em 2 minutos.",
      alojamiento: "Configurando sua propriedade? Veja como deixar tudo certinho.",
      tarifas: "Dúvidas sobre preços? Deixa eu te explicar as tarifas por canal.",
      calendario: "Quer dominar o calendário? Reservas, preços e disponibilidade.",
      huesped: "Vamos automatizar a jornada do hóspede? Eu te mostro passo a passo.",
      autoridades: "Vamos conectar as autoridades? Envie relatórios de viajantes em 1 vídeo.",
    },
  },
  // ── NovedadesDrawer.vue ──
  news: {
    ariaPanel: "Novidades do sistema",
    latestUpdates: "Últimas atualizações",
    close: "Fechar",
    tabNews: "Novidades",
    reports: "Relatos",
    loading: "Carregando…",
    emptyNews: "Nenhuma novidade ainda. Você verá as melhorias aqui assim que as publicarmos.",
    showMore: "Mostrar mais",
    showLess: "Mostrar menos",
    reportProblem: "Relatar um problema",
    emptyReports: "Você ainda não enviou nenhum relato.",
    sendReport: "+ Enviar um relato",
    sendNewReport: "+ Enviar um novo relato",
    capturesCount: "{count} captura de tela | {count} capturas de tela",
    viewConversation: "Ver conversa →",
    new: "Novo",
    openedOn: "aberto em {date}",
    conversationWithSupport: "Conversa com a equipe de suporte",
    you: "Você",
    support: "Suporte",
    noReplyYet: "Ninguém da equipe respondeu ainda. Avisaremos você aqui assim que responderem.",
    replyPlaceholder: "Escreva sua resposta…",
    send: "Enviar",
    replyHint: "<b>Enter</b> envia · <b>Shift + Enter</b> nova linha",
    back: "Voltar",
    sendReportTitle: "Enviar um relato",
    formSubtitle: "Conte o que aconteceu e vamos investigar. Você verá a resposta nos seus relatos.",
    about: "Sobre",
    whatHappens: "O que está acontecendo?",
    titlePlaceholder: "Resuma em uma frase",
    describeDetail: "Descreva em detalhes",
    descPlaceholder: "O que você esperava, o que aconteceu e como reproduzir.",
    capture: "Captura de tela",
    optional: "opcional",
    attachHint: "Toque para anexar uma imagem",
    sending: "Enviando…",
    submitReport: "Enviar relato",
    prev: "Anterior",
    next: "Próximo",
    today: "Hoje",
    yesterday: "Ontem",
    status: {
      open: "Aberto",
      in_progress: "Em andamento",
      resolved: "Resolvido",
      closed: "Fechado",
    },
    errRequired: "Conte o que está acontecendo.",
    errSend: "Não foi possível enviar. Tente novamente.",
  },
  // ── VerifyIdentity.vue ──
  verify: {
    title: "Verificação de identidade",
    subtitle: "Para concluir seu check-in, precisamos verificar sua identidade",
    idDocument: "Documento de identidade",
    idDocumentDesc: "Tire uma foto nítida da frente do seu documento (DNI, NIE, carteira de identidade, passaporte ou habilitação)",
    selfie: "Selfie",
    selfieDesc: "Tire uma selfie em que seu rosto apareça claramente",
    requirements: "Requisitos:",
    req1: "Boa iluminação",
    req2: "Documento inteiro dentro do quadro",
    req3: "Texto legível",
    req4: "Selfie sem acessórios cobrindo o rosto",
    start: "Iniciar verificação",
    frontTitle: "Frente do documento",
    alignDocument: "Alinhe o documento dentro do quadro",
    hintLegible: "Verifique se todos os dados estão legíveis",
    faceTitle: "Verificação facial",
    alignFace: "Alinhe o rosto dentro do círculo",
    hintLookCamera: "Olhe diretamente para a câmera, sem acessórios",
    reviewTitle: "Revise suas fotos",
    reviewSubtitle: "Verifique se todas as imagens estão nítidas e legíveis",
    frontDocTitle: "Frente do documento",
    retake: "Refazer",
    back: "Voltar",
    submit: "Enviar para verificação",
    processingTitle: "Verificando sua identidade",
    processingDesc: "Estamos validando seus documentos. Isso pode levar alguns segundos...",
    dontClose: "Não feche esta janela",
    successTitle: "Verificação concluída com sucesso!",
    successDesc: "Sua identidade foi verificada com sucesso.",
    continue: "Continuar",
    errorTitle: "Erro na verificação",
    couldNotVerify: "Não foi possível verificar sua identidade. Tente novamente.",
    retry: "Tentar novamente",
    cameraErrorTitle: "Não foi possível acessar a câmera",
    cameraErrorDesc: "Não conseguimos acessar sua câmera. Verifique as permissões e tente novamente.",
    suggestions: "Sugestões:",
    tip1: "Verifique se você concedeu as permissões de câmera",
    tip2: "Verifique se nenhum outro aplicativo está usando a câmera",
    tip3: "Reinicie o navegador se o problema persistir",
    tryAgainCamera: "Tentar novamente",
    couldNotVerifyShort: "Não foi possível verificar sua identidade",
    serverError: "Erro no servidor",
    tryLater: "Tente novamente mais tarde",
  },
};
